import Tooltip from '@atlaskit/tooltip';
import isNil from 'lodash/isNil';
import React from 'react';
import { EMPTY_STATE } from '../../PartnerReports.constants';
const PercentTooltip = _ref => {
  let {
    rate
  } = _ref;
  return isNil(rate) ? /*#__PURE__*/React.createElement(React.Fragment, null, EMPTY_STATE) : /*#__PURE__*/React.createElement(Tooltip, {
    content: "".concat(rate, "%")
  }, /*#__PURE__*/React.createElement("span", null, "".concat(Math.round(rate), "%")));
};
export default PercentTooltip;